import React from "react"

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const CloseIcon = props => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.251 10.2508L38.2485 38.2487"
      strokeWidth="3.5"
      strokeLinecap="round"
    />
    <path
      d="M38.251 10.2507L10.2535 38.2486"
      strokeWidth="3.5"
      strokeLinecap="round"
    />
  </svg>
)
